// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"295":"7d5dee2d","776":"27fb6366","959":"cb01f744"}[chunkId] + ".css";
};